<template>
    <div :class="['tabs', theme]">
        <div class="tabs__titles-container" v-if="isDesktopView">
            <div class="tabs__wrap">
                <div class="tabs__titles-container-wrapper">
                    <div :class="getTabClass(tab)" @click="onTabClick(tab)" :key='tab.id' v-for="tab in tabs">
                        {{ tab.title }}
                    </div>
                </div>
            </div>
        </div>

        <div class="tabs__select-container" v-if="isMobileView">
            <TotemSelect
                :options="mobileTabsOptions"
                :value="selectedTab"
                @input="openSelectedTab"
                :clearable="false"
                size="large"
            />
        </div>
        <slot name="additionalTabsContent"></slot>
        <div class="tabs__wrap">
            <div class="tab-content">
                <slot name="tabsContent" :onTabMounted="onTabMounted" :activeTab="activeTab"></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            theme: {
                type: String,
                validator: (prop) => [ 'basic', 'landing-page' ].includes(prop),
                default: 'basic'
            }
        },
        data () {
            return {
                tabs: [],
                activeTab: null
            }
        },
        provide: function () {
            return {
                activateTab: this.activateTab
            }
        },
        computed: {
            mobileTabsOptions () {
                return this.tabs.map(tab => ({
                    label: tab.title,
                    value: tab.id
                }))
            },
            selectedTab () {
                return this.mobileTabsOptions.find(tab => tab.value === this.activeTab.id)
            }
        },
        methods: {
            onTabClick (tab) {
                this.activeTab = tab
            },
            openSelectedTab (option) {
                this.activeTab = this.tabs.find(tab => tab.id === option.value)
            },
            activateTab (tabId) {
                this.activeTab = this.tabs.find(tab => tab.id === tabId)
            },
            onTabMounted (tab) {
                if (!this.activeTab) {
                    this.activeTab = tab
                }
                this.tabs.push(tab)
            },
            getTabClass (tab) {
                const tabClass = ['tabs__tab-title']
                if (tab.id === this.activeTab.id) {
                    tabClass.push('tabs__tab-title--active')
                }
                return tabClass
            }
        }
    }
</script>

<style lang="scss">

.tabs {
    @mixin after-bar {
        bottom: 0;
        content: '';
        height: 3px;
        position: absolute;
        width: 100%;
    }
    @mixin transiton {
        transition: all 0.3s;
    }
    align-items: center;

    &__select-container {
        display: flex;
        justify-content: center;
        margin-top: 50px;
    }

    &__titles-container-wrapper {
        display: flex;
    }

    &__tab-title {
        @include transiton;
        color: #000;
        cursor: pointer;
        font-family: Nunito-Bold, sans-serif;
        font-size: 2rem;
        padding: 20px;
        position: relative;

        &--active,
        &:hover {
            color: $orange;
        }

        &::after,
        &:hover::after {
            @include after-bar;
            @include transiton;
            background-color: $orange;
            left: 50%;
            transform: translateX(-50%);
            width: calc(100% - 40px);
            z-index: 1;
        }

        &--active::after {
            width: 100% !important;
        }

        &::after {
            width: 0;
        }
    }

    &.landing-page {
        .tabs__wrap {
            padding: 0 20px;
        }

        .tabs__titles-container {
            position: relative;

            &::after {
                @include after-bar;
                background-color: $light_orange;
                z-index: 0;
            }
        }
    }
}
</style>
